module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_WUR_image_4.a4307cba.png";